import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import NavBar from "./NavBar";
import Footer from "./Footer";
import CardTiposDePagamentos from "./CardTiposDePagamentos";
import InputPagamento from "../components/Inputs/InputPagamento";
import PaymentMonthsSelector, {
  QUARTER_OPTIONS,
} from "../components/PaymentMonthsSelector";
import { API_BASE_URL } from "../services/api";
import { CheckCheck, ChevronLeft, LoaderCircle, OctagonAlert } from "lucide-react";
import { jwtDecode } from "jwt-decode";

export default function PagamentoEmpresaTrimestre() {
  const { id } = useParams();
  const [plano, setPlano] = useState({});
  const [contador, setContador] = useState(0);
  const [numeroMpesa, setNumeroMpesa] = useState(null);
  const [mensagemInput, setMensagemInput] = useState("");
  const [perfil, setPerfil] = useState("");
  const [profile, setProfile] = useState("");
  const [pago, setPago] = useState(false);
  const [reciboId, setReciboId] = useState(null);
  const [preco, setPreco] = useState();
  const [meses, setMeses] = useState(3);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const totalPagamento = Number(preco || 0) * (meses / 3);

  const gerarDataAtual = () => {
    const dataAtual = new Date();
    // Obtém as partes da data
    const ano = dataAtual.getFullYear();
    const mes = String(dataAtual.getMonth() + 1).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
    const dia = String(dataAtual.getDate()).padStart(2, "0");

    // Obtém as partes do horário
    const horas = String(dataAtual.getHours()).padStart(2, "0");
    const minutos = String(dataAtual.getMinutes()).padStart(2, "0");
    const segundos = String(dataAtual.getSeconds()).padStart(2, "0");

    // Constrói a data no formato desejado
    const dataFormatada = `${ano}-${mes}-${dia} ${horas}:${minutos}:${segundos}`;
    return dataFormatada;
  };

  async function mostrar() {
    try {
      const token = localStorage.getItem("token");
      const dados = await axios.get(
        `${API_BASE_URL}/planoempresarialtrimestral/${id}`,
        {
          headers:{
            'Authorization': `Bearer ${token}`,  // Substitua pelo seu token de autenticação, se necessário
            'Content-Type': 'application/json'  // Define o tipo de conteúdo como JSON
          }
        }
      );
      if (dados.data.plano === "PLANO-6Mbps") {
        setPerfil("Plano ferro 3Mbps");
      } else if (dados.data.plano === "PLANO-8Mbps") {
        setPerfil("Plano Prata 5Mbps");
      } else if (dados.data.plano === "PLANO-10Mbps") {
        setPerfil("Plano Cobre 8Mbps");
      } else if (dados.data.plano === "PLANO-12Mbps") {
        setPerfil("Plano Aluminio 10Mbps");
      } else if (dados.data.plano === "PLANO-14Mbps") {
        setPerfil("Plano Ouro 12Mbps");
      } else if (dados.data.plano === "PLANO-16Mbps") {
        setPerfil("Plano Chumbo 14Mbps");
      } else if (dados.data.plano === "PLANO-18Mbps") {
        setPerfil("Plano Mercurio 16Mbps");
      } else if (dados.data.plano === "PLANO-20Mbps") {
        setPerfil("Plano 18Mbps");
      }
      setProfile(dados.data.plano);
      setPreco(dados.data.preco);
      setPlano(dados.data);
    } catch (erro) {
      console.log(erro);
    }
  }

  const gerarLetrasAleatorias = (tamanho) => {
    const letras = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    let resultado = "";
    for (let i = 0; i < tamanho; i++) {
      resultado += letras.charAt(Math.floor(Math.random() * letras.length));
    }
    return resultado;
  };

  async function recarregarPacote() {
    setMensagemInput("");
    setLoading(true);
    try {
      if (!/^(84|85)\d{7}$/.test(numeroMpesa)) {
        console.log(
          "Número de telefone inválido. Deve começar com 84 ou 85 e conter 9 dígitos."
        );
        setLoading(false);
        setMensagemInput(
          "Por favor, insira um número de telefone válido no maximo 9 numeros começando com 84 ou 85."
        );
        return;
      }
      let valoresAleatorios = gerarLetrasAleatorias(12);
      const token = localStorage.getItem("token");
      if(token){
        const dadosDoLocalStorage = jwtDecode(token)
        if(!dadosDoLocalStorage){
          console.log("Token não encontrado no localStorage.");
          return;
        }
        if (!profile || !Number.isFinite(Number(preco))) {
          setMensagemInput("Aguarde os dados do plano carregarem.");
          return;
        }

        const valorTotal = Number(preco) * (meses / 3);

        if (!Number.isFinite(valorTotal) || valorTotal <= 0) {
          setMensagemInput("Valor do pagamento invalido.");
          return;
        }

          // PAGAMENTO MPESA
      const dadosPagamento = await axios.put(
        `${API_BASE_URL}/pagamentotrimestre/${dadosDoLocalStorage.idUsuario}`,
        {
          transaction_ref: "EyazsImperium",
          msisdn: `258${numeroMpesa}`,
          amount: valorTotal,
          precoPlano: parseFloat(preco),
          meses,
          thirdparty_ref: valoresAleatorios,
          profile,
          descricao: profile,
          gerarRecibo: true,
        },
        {
          headers:{
            'Authorization': `Bearer ${token}`,  // Substitua pelo seu token de autenticação, se necessário
            'Content-Type': 'application/json'  // Define o tipo de conteúdo como JSON
          }
        }
      );
      if (dadosPagamento) {
        if (dadosPagamento.data?.reciboId) {
          setReciboId(dadosPagamento.data.reciboId);
          setPago(true);
          return;
        }
        if (dadosPagamento.data?.reciboPendente) {
          setReciboId(null);
          setMensagemInput("Pagamento confirmado. Recibo pendente para o super admin gerar.");
          setPago(true);
          return;
        }
        //ATUALIZAR PROFILE
        try {
          const atualizarProfile = await axios.put(
            `${API_BASE_URL}/usuario/${dadosDoLocalStorage.idUsuario}`,
            {
              profile: profile,
            },
            {
              headers:{
                'Authorization': `Bearer ${token}`,  // Substitua pelo seu token de autenticação, se necessário
                'Content-Type': 'application/json'  // Define o tipo de conteúdo como JSON
              }
            }
          );
          if (atualizarProfile) {
            console.log("Plano atualizado com Sucesso!");
            try {
              if (atualizarProfile) {
                console.log("plano atualizado!");
                const atualPrecoUsuario = await axios.put(
                 `${API_BASE_URL}/usuario/${dadosDoLocalStorage.idUsuario}`,
                  {
                    precousuario: parseFloat(preco),
                    profileusuario: profile,
                    validadeusuario:
                      meses === 3 ? "3 meses" : `${meses} meses trimestral`
                  },
                  {
                    headers:{
                      'Authorization': `Bearer ${token}`,  // Substitua pelo seu token de autenticação, se necessário
                      'Content-Type': 'application/json'  // Define o tipo de conteúdo como JSON
                    }
                  }
                );
                if (atualPrecoUsuario) {
                  console.log(
                    "Preco e Plano do usuario Atualizados com Sucesso!"
                  );
                  try {
                    const dataAtual = gerarDataAtual();
                    const gerarRecibo = await axios.post(
                      `${API_BASE_URL}/recibo`,
                      {
                        idUsuario: dadosDoLocalStorage.idUsuario,
                        userName: dadosDoLocalStorage.name,
                        meioPagamento: "Mpesa",
                        numeroTelefone: numeroMpesa,
                        valor: valorTotal,
                        plano: profile,
                        descricao: profile,
                        dataTransacao: dataAtual,
                      },
                      {
                        headers:{
                          'Authorization': `Bearer ${token}`,  // Substitua pelo seu token de autenticação, se necessário
                          'Content-Type': 'application/json'  // Define o tipo de conteúdo como JSON
                        }
                      }
                    );
                    if (gerarRecibo) {
                      setReciboId(gerarRecibo.data?.reciboId || null);
                      console.log("Recibo gerado com Sucesso!");
                      setPago(true);
                    }
                  } catch (erro) {
                    console.log(erro);
                  }
                }
                console.log("Plano atualizado com Sucesso!");
              }
            } catch (erro) {
              console.log(erro);
            }
          } else {
            console.log("Erro ao realizar o pagamento");
            setMensagemInput("Clique novamente em Pagar");
          }
        } catch (erro) {
          console.log(erro);
        }
      }
      }
    } catch (erro) {
      console.log("Erro ao recarregar pacote:", erro.message);
    } finally {
      setNumeroMpesa("");
      setLoading(false);
    }
  }
  const propsCardPlanoResidencial = {
    url: "../../images/vodacom.png",
    descricao: "Pagamento via M-pesa",
  };

  const propsCardPlanoEmpresarial = {
    url: "../../images/movitel.jpeg",
    descricao: "Pagamento via E-mola",
  };

  const propsInputPagamentoMpesa = {
    type: "number",
    placeholder: "digite o numero do Mpesa",
    mudar: (e) => setNumeroMpesa(e.target.value),
    numeroMpesa: numeroMpesa,
  };

  useEffect(() => {
    mostrar();
    console.log(numeroMpesa)
    console.log(preco)
    console.log(profile)

  }, []);

  return (
    <div className="flex h-screen flex-col justify-between">
      {/* NavBar */}
      <div className="bg-blue-500 h-[300px] sticky top-0 z-10">
        <NavBar />
      </div>
      {/* Conteúdo Principal */}
      {pago ? (
        <div>
          <div className="flex justify-center items-center h-full">
            <div className="bg-green-700 m-8 text-white p-6 md:p-10 rounded-3xl shadow-2xl max-w-md w-full text-center">
              <div className="flex justify-center mb-4">
                <CheckCheck size={50} strokeWidth={2} />
              </div>
              <h1 className="text-2xl md:text-3xl font-bold mb-2">
                Pagamento Confirmado!
              </h1>
              <p className="text-lg md:text-xl mb-4">
                Obrigado pelo seu pagamento. Seu plano foi atualizado com
                sucesso.
              </p>
              <Link
                to="/home"
                className="inline-block mt-4 px-6 py-2 rounded-lg bg-green-500 text-gray-100 hover:bg-green-600 transition duration-300 font-semibold"
              >
                Voltar à Página Inicial
              </Link>
              {reciboId && (
                <Link
                  to={`/recibo/${reciboId}`}
                  className="ml-0 inline-block mt-3 px-6 py-2 rounded-lg bg-white text-green-700 hover:bg-green-50 transition duration-300 font-semibold sm:ml-3"
                >
                  Ver recibo
                </Link>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="flex-grow px-4 sm:px-6 md:px-8 lg:px-16 xl:px-20 mx-auto my-6">
          <button
            className="group"
            onClick={() => {
              navigate(-1);
            }}
          >
            <div className="flex md:block lg:hidden">
              <div>
                <ChevronLeft className="group-hover:font-semibold" />
              </div>
              <div>
                <span className="text-sm group-hover:font-semibold">
                  Voltar
                </span>
              </div>
            </div>
          </button>
          {contador === 0 ? (
            <div className="flex flex-wrap justify-center sm:mt-[40px] sm:justify-between gap-4 max-w-2xl mx-auto px-4 z-0">
              <button
                onClick={() => setContador(1)}
                className="flex flex-wrap justify-center sm:justify-between gap-4 max-w-2xl mx-auto px-4 z-0"
              >
                <CardTiposDePagamentos {...propsCardPlanoResidencial} />
              </button>

              <button
                onClick={() => {
                  alert("Tipo de Pagamento nao Disponivel...");
                  //setContador(2)
                }}
                className="flex flex-wrap justify-center sm:justify-between gap-4 max-w-2xl mx-auto px-4 z-0"
              >
                <CardTiposDePagamentos {...propsCardPlanoEmpresarial} />
              </button>
            </div>
          ) : (
            <div className="flex flex-col h-full font-questrial">
              <div className="h-14 border flex items-center justify-center bg-gray-100">
                <h2 className="font-semibold">Detalhes de Pagamento</h2>
              </div>

              <div className="mt-6 w-full max-w-5xl mx-auto px-4 sm:px-6 md:px-8">
                <div className="flex flex-wrap justify-between gap-6">
                  <div className="flex flex-wrap justify-between gap-6">
                    {/* Descrição do Plano e Dados Bancários */}
                    <div className="w-full md:w-[68%] flex flex-col text-sm text-gray-600 md:mx-auto">
                      <div className="border bg-gray-50 p-4">
                        <h2 className="text-center font-semibold mb-2">
                          Descrição do Plano
                        </h2>
                        <p>
                          <strong>Plano:</strong> {plano.plano}
                        </p>
                        <p>
                          <strong>Descrição:</strong> {plano.descricao}
                        </p>
                        <p>
                          <strong>Validade/Renovação:</strong> {plano.validade}{" "}
                        </p>
                        <p>
                          <strong>Taxa de Mensalidade:</strong> {plano.preco}{" "}
                          MZN
                        </p>
                      </div>
                      <div className="border bg-gray-50 p-4 mt-4">
                        <h2 className="text-center font-semibold mb-2">
                          Dados Bancários para Pagamento
                        </h2>
                        <p>
                          <strong>Banco:</strong> Banco Comercial de
                          Investimento (BCI)
                        </p>
                        <p>
                          <strong>Titular:</strong> EYAZS IMPERIUM
                        </p>
                        <p>
                          <strong>Conta:</strong> 183 034 830 100 01
                        </p>
                        <p>
                          <strong>NIB:</strong> 0008 0000 8303 4830 101 95
                        </p>
                        <p>
                          <strong>IBAN:</strong> MZ59 0008 0000 8303 4830 101 95
                        </p>
                        <p>
                          <strong>SWIFT:</strong> CGDIMZM
                        </p>
                      </div>
                    </div>

                    {/* Pagamento e Resumo */}
                    <div className="w-full md:w-[68%] md:mx-auto border bg-gray-50 p-4">
                      <div className="flex justify-center mb-4">
                        <img
                          className="w-32"
                          src="../../images/vodacom.png"
                          alt="Vodacom"
                        />
                      </div>
                      <div className="flex justify-between mb-4">
                        <span>Total</span>
                        <span className="font-semibold">
                          {totalPagamento.toLocaleString("pt-MZ")} MZN
                        </span>
                      </div>
                      <PaymentMonthsSelector
                        meses={meses}
                        onChange={setMeses}
                        total={totalPagamento}
                        options={QUARTER_OPTIONS}
                        diasPorMes={30}
                      />
                      <InputPagamento {...propsInputPagamentoMpesa} />
                      {loading ? (
                        <button className="w-full mt-4 bg-blue-500 p-2 text-white rounded-lg">
                          <div className="flex justify-center items-center gap-1">
                            <span>Processando</span>
                            <LoaderCircle
                              strokeWidth={4}
                              size={18}
                              className={
                                loading ? "animate-spin text-white" : ""
                              }
                            />
                          </div>
                        </button>
                      ) : (
                        <button
                          onClick={() => {
                            recarregarPacote(); // Certifique-se de que esta função esteja corretamente definida
                          }}
                          className="w-full mt-4 bg-blue-500 p-2 text-white rounded-lg"
                        >
                          Pagar
                        </button>
                      )}
                      {mensagemInput && (
                        <div className="flex items-center text-sm mt-2 p-4 bg-red-500 text-white rounded-lg">
                          <OctagonAlert />
                          <span>{mensagemInput}</span>
                        </div>
                      )}
                      <p className="text-xs text-gray-400 mt-4">
                        Ao clicar "Pagar", eu confirmo que li e estou de acordo{" "}
                        <Link className="text-blue-500" to="/termosdeuso">
                          com os termos e condições de uso
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Footer */}
      <div className="bg-blue-500 text-gray-200">
        <Footer />
      </div>
    </div>
  );
}
